module.exports = __webpack_public_path__ + "static/img/ETH.0c36f85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ETH.png
// module id = 52wP
// module chunks = 2